
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPieChart as ObcPieChartElement} from '@oicl/openbridge-webcomponents/dist/bars-graphs/pie-chart/pie-chart.js';
 
 
 

 
 export const ObcPieChart = createComponent({
   react: React,
   tagName: 'obc-pie-chart',
   elementClass: ObcPieChartElement,
   events: {
     
   }
  });
 
 